<template>
  <div class="w100 h100 bcg_w work_time">
    <a-spin :spinning="requesting">
      <a-row justify="center">
        <a-page-header title="工时录入" />
      </a-row>
      <a-row justify="center">
        <a-col :span="3" v-if="isLeader">
          <a-form-item label="组员" :wrapperCol="{ span: 18 }">
            <a-select v-model:value="groupMember" show-search placeholder="请选择组员" label-in-value option-filter-prop="label" option-label-prop="label" style="width: 100%" :filter-option="true">
              <a-select-option v-for="user in deptUserListData" :key="user.userId" :label="user.userCode" :value="user.userId">{{ user.userCode }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6" style="text-align: center">
          <a-form-item label="时间" style="text-align: center"> <a-week-picker v-model:value="selectWeekDay" :disabled-date="disabledDate" placeholder="请选择周" style="height: 32px" @change="weekChange" /> {{ `(${lastMonday}~${lastSunday})` }}</a-form-item>
        </a-col>
        <a-col>
          <a-radio-group v-model:value="sizeWeek" button-style="solid" @change="sizeWeekChange">
            <a-radio-button value="lastWeek">上周</a-radio-button>
            <a-radio-button value="thisWeek">本周</a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>
      <a-row justify="center" style="margin-bottom: 16px">
        <a-col :span="2" style="text-align: center"> 渠道 </a-col>
        <a-col :span="4" style="text-align: center"> 产品 </a-col>
        <a-col :span="3" style="text-align: center"> 时间 </a-col>
        <a-col :span="1"></a-col>
      </a-row>
      <template v-for="(item, index) in listData" :key="index">
        <a-row justify="center" style="margin-bottom: 16px">
          <a-col :span="2">
            <a-select v-model:value="item.channelValue" show-search placeholder="请选择渠道" label-in-value option-filter-prop="label" option-label-prop="label" style="width: 100%" :filter-option="true">
              <a-select-option v-for="channel in channelList" :key="channel.value" :label="channel.label" :value="channel.value">{{ channel.label }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="4">
            <a-select v-model:value="item.projectValue" show-search placeholder="请选择产品" label-in-value option-filter-prop="label" option-label-prop="label" style="width: 100%" :filter-option="true">
              <a-select-option v-for="project in projectList" :key="project.projectCode" :label="project.projectName" :value="project.projectCode">{{ project.projectName }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="3">
            <a-input placeholder="请输入工时" v-model:value="item.hourRate" suffix="%" style="text-align: center" @change="onLaborHourRatioChange(index)" />
          </a-col>
          <a-col :span="1">
            <a style="position: relative; left: 1em; top: 0.3em" href="javascript:void(0);" @click="deleteWorkTime(index, item)">删除</a>
          </a-col>
        </a-row>
      </template>

      <a-row justify="center">
        <a-space>
          <a-button type="primary" @click="addWorkTimeList" :disabled="funcDisabled">新增工时</a-button>
          <a-button type="primary" @click="saveWorkTimeForm" :disabled="funcDisabled">保存</a-button>
          <a-popconfirm title="确认要清空吗?" ok-text="清空" cancel-text="取消" @confirm="cleanWorkTimeForm" :disabled="funcDisabled">
            <a-button type="primary" danger :disabled="funcDisabled">清空</a-button>
          </a-popconfirm>
        </a-space>
      </a-row>
      <a-row justify="center">
        <div style="margin-top: 16px; color: #ff0000; font-size: 14px">
<!--          <span v-if="!isLeader && funcDisabled">工时仅可在周五14:00 至 周一22:00填写</span>-->
          <span v-if="!isLeader && funcDisabled">工时仅可在周四 至 周日填写</span>
        </div>
      </a-row>
    </a-spin>
  </div>
</template>

<script>
import { getProjectListData } from '@/api/base/project.js';
import { getWorkWeekTimeData, addWorkWeekTimeData } from '@/api/user/index.js';
import { getDeptUserListData } from '@/api/org/account.js';
import moment from 'moment';
import { mapState } from 'vuex';
import _ from 'lodash';
import axios from '@/utils/axios';

export default {
  data() {
    return {
      allowSaveWorkingHours:'3',
      moment,
      listData: [],
      projectList: [],
      channelList: [
        { label: '头条', value: 'TT' },
        { label: '快手', value: 'KS' },
        { label: '腾讯', value: 'TX' },
        { label: '爱奇艺', value: 'AQY' },
        { label: 'Bilibili', value: 'Bilibili' },
        { label: '支付宝', value: 'ZFB' },
        { label: '小红书', value: 'XHS' },
        { label: '腾讯', value: 'TX' },
        { label: '海外', value: 'HIW' },
        { label: '其他', value: 'OTHER' }
      ],
      deptUserListData: [],
      requesting: false,
      selectWeekDay: null,
      lastMonday: null,
      lastSunday: null,
      sizeWeek: 'lastWeek',
      groupMember: undefined,
      now: undefined,
    };
  },
  computed: {
    ...mapState({
      userId: state => state.oauth.userInfo.userId,
      isLeader: state => state.oauth.userInfo.grades == 'GROUPLEADER' || state.oauth.userInfo.grades == 'MANAGER',
    }),
    funcDisabled() {
      console.error("funcDisabled - allowSaveWorkingHours : "+ this.allowSaveWorkingHours)
      this.isAllowSaveWorkingHours();
      if(this.allowSaveWorkingHours === '1'){
        console.error("funcDisabled - allowSaveWorkingHours : false")
        return false;
      }
      if(this.allowSaveWorkingHours === '0' ){
        return true;
      }

      if (this.isLeader) {
        return false;
      }
      let weekday = this.now.getDay();
      if (weekday >= 1  &&  weekday <= 3 ) {
        return false;
      }else{
        return false;
      }

      // if (weekday == 0 || weekday == 6) {
      //   return false;
      // } else {
      //   if (weekday == 5) {
      //     return this.now.getHours() < 14;
      //   } else if (weekday == 1) {
      //     return this.now.getHours() > 22;
      //   } else {
      //     return true;
      //   }
      // }
    },
  },
  beforeCreate() {

  },
  created() {
    this.isAllowSaveWorkingHours();
    this.now = new Date();
    this.getProjectList();
    this.sizeWeekChange();
  },
  mounted() {
    if (this.isLeader) {
      this.getDeptUser();
    }
  },
  methods: {
    async isAllowSaveWorkingHours() {
      this.allowSaveWorkingHours = await axios.get('/sys/labor/hour/is_allow_save_working_hours').then(res => {
        return res.msg || '3';
      });
      return this.allowSaveWorkingHours;
    },
    /**
     * @description: 限制不能选择本周之后的日期
     * @param {*} current
     * @return {*}
     */
    disabledDate(current) {
      const weekDay = _.cloneDeep(current).endOf('week').subtract(1, 'week');
      return weekDay > moment().endOf('day');
    },
    /**
     * @description: 上周本周按钮变化
     * @param {*}
     * @return {*}
     */
    sizeWeekChange() {
      if (this.sizeWeek == 'lastWeek') {
        const weekDay = moment().startOf('week').subtract(1, 'week');
        this.selectWeekDay = weekDay;
        this.weekChange(weekDay);
      } else {
        this.selectWeekDay = moment();
        this.weekChange(moment());
      }
    },
    /**
     * @description: 时间周数发生改变
     * @param {Moment} date 选中的时间
     * @return {*}
     */
    weekChange(date) {
      const lastWeekStart = moment().startOf('week').subtract(1, 'week');
      const lastWeekEnd = moment().endOf('week').subtract(1, 'week');
      const nowWeekStart = moment().startOf('week');
      const nowWeekEnd = moment().endOf('week');
      if (lastWeekStart <= moment(date) && moment(date) <= lastWeekEnd) {
        this.sizeWeek = 'lastWeek';
      } else if (nowWeekStart <= moment(date) && moment(date) <= nowWeekEnd) {
        this.sizeWeek = 'thisWeek';
      } else {
        this.sizeWeek = null;
      }
      const weekOfDay = moment(date).format('E');
      this.lastMonday = moment(date)
        .subtract(weekOfDay - 1, 'days')
        ?.format('YYYY-MM-DD');
      this.lastSunday = moment(date)
        .add(7 - weekOfDay, 'days')
        ?.format('YYYY-MM-DD');
      this.getWorkTime();
    },
    projectListDisabled(project) {
      return this.listData.some(item => {
        if (item.projectValue) {
          return item.projectValue.value == project.projectCode;
        } else {
          return false;
        }
      });
    },
    // 获取产品列表
    async getProjectList() {
      this.requesting = true;
      let res = await getProjectListData({});
      this.projectList = res.page.list;
    },
    async getWorkTime() {
      const selectStartDay = this.selectWeekDay.startOf('week');
      let res = await getWorkWeekTimeData({
        week: selectStartDay?.format('WW'),
        year: selectStartDay?.format('YYYY'),
      });
      if (res.data?.length > 0) {
        this.listData = [];
        res.data.forEach(item => {
          this.listData.push({ hourRate: item.hourRate, projectValue: { key: item.projectCode, label: item.projectName, value: item.projectCode }, channelValue: { key: item.channelCode, label: item.channelName, value: item.channelCode } });
        });
      } else {
        this.listData = [{ hourRate: 0, projectValue: undefined, channelValue: undefined }];
      }
      this.requesting = false;
    },
    async getDeptUser() {
      const res = await getDeptUserListData({
        deptId: this.$store.state.oauth.userInfo.deptId + '',
        page: '1',
        pageSize: 1000,
      });

      if (res.page.list?.length > 0) {
        this.deptUserListData = res.page.list;
      }
    },
    addWorkTimeList() {
      this.listData.push({ hourRate: 0, projectValue: undefined, channelValue: undefined });
    },
    deleteWorkTime(index) {
      let item = this.listData[index];
      if (!item.id) {
        this.listData.splice(index, 1);
      }
    },
    onLaborHourRatioChange(index) {
      let input = this.listData[index].hourRate.toString().replace(/\D{1,}/, '');
      this.listData[index].hourRate = input > 100 ? 100 : input;
    },
    saveWorkTimeForm() {
      let postData = this.listData;
      let sumTime = 0;
      let projectCodeCol = [];

      for (let item of postData) {
        if (item.projectValue == null || item.hourRate == null || item.channelValue == null) {
          this.$message.error('请填写全部内容');
          return;
        }
        // //判断是否有重复产品
        // if (projectCodeCol.includes(item.projectValue.value)) {
        //   this.$message.error('请勿选择相同产品');
        //   return;
        // }
        //projectCodeCol.push(item.projectValue?.value);

        //判断是否重复的产品和渠道
        let projectChannelCode = item.projectValue.value + item.channelValue.value;
        if (projectCodeCol.includes(projectChannelCode)) {
          this.$message.error('请勿选择相同渠道和产品');
          return;
        }
        projectCodeCol.push(projectChannelCode);

        item.projectCode = item.projectValue?.value;
        item.projectName = item.projectValue?.label;
        item.channelCode = item.channelValue?.value;
        item.channelName = item.channelValue?.label;
        sumTime += Number(item.hourRate);
      }

      if (sumTime != 100) {
        this.$message.error('时间之和必须等于100');
        return;
      }
      this.requesting = true;
      const selectStartDay = this.selectWeekDay.startOf('week');
      const params = {
        list: postData,
        userId: this.groupMember ? this.groupMember.value : this.userId,
        startDate: this.lastMonday,
        endDate: this.lastSunday,
        week: selectStartDay?.format('WW'),
        year: selectStartDay?.format('YYYY'),
      };

      addWorkWeekTimeData(params).then(res => {
        if (res && res.code == 0) {
          this.requesting = false;
          this.$message.success('保存成功');
        }
      });
    },
    cleanWorkTimeForm() {
      this.listData = [{ hourRate: 0, projectValue: undefined, channelValue: undefined }];
    },
  },
};
</script>

<style lang="less" scopped>
.work_time {
  border-radius: 8px;
  .ant-calendar-picker {
    .ant-input {
      height: 32px !important;
    }
  }
  .ant-input {
    height: 22px !important;
  }
}
</style>